import styled from 'styled-components';

import {
    ExclSign,
    ApplSign,
} from 'ui/lexus/outlines';

export default {
    InfoBlockBox: styled.div.attrs({ className: 'info-block-box' })`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin: 5px 5px 8px;
        
        @media (min-width: 700px) {
               margin: 0 0 42px;
        }
        @media (min-width: 1200px) {
            margin: 0 0 59px;
        }
        
    `,
    InfoBlockLabel: styled.span.attrs({ className: 'info-block-label' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 32px;
        font-weight: 400;
        color: #5B6164;
        margin-bottom: 14px;
        white-space: nowrap;
        -webkit-font-smoothing: antialiased;
        font-style: normal;
        font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        @media (min-width: 700px) {
            margin-bottom: 6px;
        }
    `,
    InfoBlockStatus: styled.span.attrs({ className: 'info-block-status' })`
        width: 20px;
        height: 20px;
        background-image: url(${props => props.status && (props.status !== 'Ожидает оплаты' && props.status !== 'Захолдирован' && props.status !== 'Отменен') ? ApplSign : ExclSign});
        background-position: center;
        background-size: cover;
        margin-right: 9px;
        margin-bottom: 2px;
        &:hover::after {
            content: '${props => props.dataTitle}';
            width: 250px;
            white-space: normal;
            position: relative;
            top: 25px;
            left: 20px;
            background: #ffffff;
            border-radius: 0;
            color: #455a64;
            border: 1px solid #1A1A1A;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 1.42857143;
            font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif,serif;
            padding: 6px 8px;
            display: block;
            z-index: 1000;
            @media (min-width: 700px) {
                width: 100%;
                white-space: nowrap;
                display: table;
            }
        }
    `,
    InfoBlockText: styled.span.attrs({ className: 'info-block-text' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 25px;
        letter-spacing: .5px;
        font-weight: 400;
        color: ${props => !props.status || (props.status === 'Ожидает оплаты' || props.status === 'Захолдирован') ? '#1A1A1A' : props.status === 'Отменен' ? '#E50000' : '#4CAF50'};
        display: flex;
        align-items: center;
        white-space: normal;
        text-align: left;
        @media (min-width: 700px) {
            font-size: 26px;
            line-height: 32px;
        }
    `,
};
